import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type AttendanceSettingsEvent from 'modules/attendance/store/models/AttendanceSettingsEvent'

import Message from './_Message'

interface Props {
  settingsEvent: AttendanceSettingsEvent
}

const SettingsEvent = ({ settingsEvent }: Props) => {
  const { changes } = settingsEvent.attributes

  return (
    <Box flexDirection="column" paddingX="s16" paddingY="s12" gap="s8">
      <Box flexDirection="row" alignItems="center" gap="s12" justifyContent="spaceBetween">
        <Text size="200" color="grey1000" weight="medium">
          {settingsEvent.attributes.full_name}
        </Text>
        <Text size="200" color="grey800" weight="medium">
          {settingsEvent.timestampUI}
        </Text>
      </Box>
      {changes && (
        <Box width="s240" gap="s8">
          {Object.keys(changes).map((key) => (
            <Message
              key={`${key}-${settingsEvent.attributes.timestamp}`}
              feature={settingsEvent.attributes.event_type}
              field={key}
              values={changes[key]}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default observer(SettingsEvent)
